import axiosInstance from '../../config/axiosConfig';
import { urlAuthentication } from '../../config/apiURL';
import { extractArray, extractDataObject } from '../utils/responseHelpers';

// Register a new user
export const registerRequest = (user) => axiosInstance.post(`${urlAuthentication}/register`, user);

// Editar un usuario
export const editUserRequest = (id, user) => axiosInstance.put(`${urlAuthentication}/users/${id}`, user);

// Login a user
export const loginRequest = (user) => axiosInstance.post(`${urlAuthentication}/login`, user);

// Verify token
export const verifyTokenRequest = () => axiosInstance.get(`${urlAuthentication}/verify`);

//Obtener usuarios
export const getUsuariosRequest = async () => {
  const response = await axiosInstance.get(`${urlAuthentication}/getAllUsers`);
  return extractArray(response);
};

// Obtener usuarios por empresa
export const getUsuariosByEmpresaRequest = async (emp_codigo) => {
  const response = await axiosInstance.get(`${urlAuthentication}/users/empresa/${emp_codigo}`);
  return extractArray(response);
};

// Eliminar un usuario
export const deleteUserRequest = (id) => axiosInstance.delete(`${urlAuthentication}/users/${id}`);

// Habilitar un usuario
export const enableUserRequest = (id) => axiosInstance.put(`${urlAuthentication}/users/enable/${id}`);

// Deshabilitar un usuario
export const disableUserRequest = (id) => axiosInstance.put(`${urlAuthentication}/users/disable/${id}`);